import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getIndicateWarningByDocSelector } from '@/domain/documents';
import { getRowStatus } from '@/components/AgGrid/helpers';
import CONST from '@/domain/documents/constants';
import {
  ROW_HAS_ERROR,
  ROW_HAS_WARNING,
  ROW_PUBLISH_SCHEDULING,
} from '@/components/AgGrid/Documents/agGridThemeClasses';

const useAgGridManualConfig = () => {
  const getIndicateWarningByDoc = useSelector(getIndicateWarningByDocSelector);

  const isScheduledAcceptanceRow = useCallback(
    (params) =>
      params?.data?.rowDocumentData.tags
        ? params.data.rowDocumentData.tags.has(CONST.tags.isScheduledAcceptance)
        : false,
    [],
  );

  return useMemo(
    () => ({
      [ROW_HAS_ERROR]: (params) => getRowStatus(params) === 'error',
      [ROW_HAS_WARNING]: (params) =>
        getRowStatus(params) === 'warning' && getIndicateWarningByDoc(params?.data?.rowDocumentData),
      [ROW_PUBLISH_SCHEDULING]: (params) => isScheduledAcceptanceRow(params),
    }),
    [getIndicateWarningByDoc, isScheduledAcceptanceRow],
  );
};

export default useAgGridManualConfig;
